// extracted by mini-css-extract-plugin
export default {"nextBtn":"styles_nextBtn__PiV4L"};